import React from 'react';
import { Link } from 'react-router-dom';
import version from '../../version';
import FindUsOnlineSection from './FindUsOnlineSection';

const SiteFooter = ({ children }) => (
  <footer className="site-footer">
    <div className="container site-footer-inner">
      <div>
        <p className="site-footer-title">Preferred Services Heating & Air</p>
        <p className="site-footer-copy">
          Heating, cooling, maintenance, and indoor comfort support for Salt Lake County homes.
        </p>
      </div>
      <div className="site-footer-links">
        <Link to="/">Home</Link>
        <Link to="/service">Services</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
      </div>
      <FindUsOnlineSection />
      <div className="site-footer-meta">
        <p>
          Developed by{' '}
          <a
            href="https://sumoninjacreative.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sumo Ninja Creative
          </a>
        </p>
        <p>Version {version}</p>
        {children}
      </div>
    </div>
  </footer>
);

export default SiteFooter;
